export const CAMPAIGN_TYPES = {
  ONGOING: 'ongoing',
  ONE_OFF: 'one_off',
  ONLINE_WA_MASS: 'online_wa_mass'
};
